/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
/* eslint-disable class-methods-use-this */
import $ from 'jquery';

import 'datatables.net';

import BaseFeature from '../../foundation/base/base';
import '../../foundation/utilities/polyfills';
import { objectToArray } from '../../foundation/utilities/polyfills-methods';


// Default settings if noting is fetched from data-settings
const DEFAULT_SETTINGS = {
	searchWord: 'searchWord',
	searchFilters: 'filters',
	endPoint: 'http://127.0.0.1:3010/api/searchResultCase'
};

/**
 * Item template to render <td>
 * Possible overrides: {link: string, title: string}
 */
const itemTemplate = `
<a class="m-module-item__card m-module-preview-item__card js-anchor" href="{{link}}" title="{{title}}" data-image="{{image}}" tabIndex="-1">
	<img class="o-search-result-case__image o-search-result-case__image--hidden js-image" src="{{image}}" alt="{{title}}"/>
	<p class="m-module-preview-item__label">{{theme}}</p>
	<h3 class="m-module-preview-item__header">{{title}}</h3> 
	<span class="m-module-preview-item__cta">
		<span class="a-icon">
			<svg class="a-icon__asset">
				<use xlink:href="#Icon_Function_ChevronRight" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
			</svg>
		</span>
	</span>

</a>
`;

export class SearchCase extends BaseFeature {
	constructor(element) {
		super(element);

		// "private" state to handle filters
		this._state = {};

		this.el = element;

		// DataTable settings
		this.$datatable = '';
		this.$container = '';
		this.dataTableColumns = [];
		this.dataTableDefs = [];

		// DataTable data
		this.total = 0;

		// General datasettings
		this.settings = element.getAttribute('data-settings') ? JSON.parse(element.getAttribute('data-settings')) : {};
		this.endpoint = this.settings.endPoint ? this.settings.endPoint : DEFAULT_SETTINGS.endPoint;

		// Search form
		this.form = this.dom.form;
		this.formSettings = this.form.getAttribute('data-settings') ? JSON.parse(this.form.getAttribute('data-settings')) : {};
		this.searchWord = this.formSettings.searchWord
			? this.formSettings.searchWord
			: DEFAULT_SETTINGS.searchWord;

		// Search filters
		this.filtersContainer = this.dom.filters;
		this.filterSettings = this.filtersContainer.getAttribute('data-settings') ? JSON.parse(this.filtersContainer.getAttribute('data-settings')) : {};
		this.searchFilterKey = this.filterSettings.searchFilters
			? this.filterSettings.searchFilters
			: DEFAULT_SETTINGS.searchFilters;
		this.checkboxes = Array.forEach
			? this.filtersContainer.querySelectorAll('[data-ref="search-case__checkbox"]')
			: objectToArray(this.filtersContainer.querySelectorAll('[data-ref="search-case__checkbox"]'));

		// Actions
		this.resetAction = this.dom.resetForm;
		this.resetFiltersAction = this.dom.resetFilters;

		// Misc
		this.imageClassHide = 'o-search-result-case__image--hidden';

		// initialization
		this.initForm();
		this.initDataTables();
		this.addEventListeners();
		this.fetchdata();
		this.generateFilterUrl();
		this.setStyle();

		// Misc
		this.hideClass = 'js-hidden';
	}

	setStyle() {
		setTimeout(() => {
			const table = $('[data-ref="search-case__dataTable"]');
			const tr = $('tr');
			const tableRows = $(table).find(tr);
			const moduleItemCards = $(table).find('.m-module-item__card');

			if (moduleItemCards) {
				$(moduleItemCards).each((index, card) => {
					$(card).addClass('m-module-item__card--hide-outline');
				});
			}

			if (tableRows) {
				$(tableRows).each((index, row) => {
					const card = $(row).find('.m-module-item__card');
					$(row).addClass('hide-outline');

					row.addEventListener('click', () => {
						$(row).addClass('hide-outline');
						$(card).addClass('m-module-item__card--hide-outline');
					});

					row.addEventListener('keyup', (e) => {
						if (e.code === 'Tab') {
							$(row).removeClass('hide-outline');
							$(card).removeClass('m-module-item__card--hide-outline');
						}
					});
				});
			}
		}, 500);
	}

	/** ******************
	 * Event Listeners
	 *
	 ******************* */

	/**
	 * Add Eventlisteners to class variables
	 * @returns void
	 */
	addEventListeners() {
		this.form.addEventListener('submit', e => this.onSubmit(e));
		this.resetFiltersAction.addEventListener('click', () => this.resetFilters());
		this.resetAction.addEventListener('click', e => this.resetForm(e));

		// Event for restructure search results before printing
		if (document.querySelector('.o-search-result-case')) {
			window.addEventListener('beforeprint', () => this.toggleImages(true));
		}

		// Paint images correct after printing
		if (document.querySelector('.o-search-result-case')) {
			window.addEventListener('afterprint', () => {
				this.$datatable.DataTable().ajax.reload();
				this.toggleImages(false);
			});
		}

		// eslint-disable-next-line no-restricted-syntax
		for (const checkbox of this.checkboxes) {
			checkbox.addEventListener('click', e => this.toggleFilter(e));
		}
	}

	/** ******************
	 * Form and filters
	 *
	 ******************* */

	/**
	 * Initialize form and set values of input and filters.
	 * Primarily used when reloading page or linking to page with query parameters set.
	 *
	 * @returns void
	 */
	initForm() {
		// Set value of form input
		this.dom.input.value = this.getSearchValue(this.searchWord) ? this.getSearchValue(this.searchWord) : '';

		// Check if reset should be visible
		if (this.dom.input.value.length > 0) {
			this.toggleResetVisibility();
		}

		// Set value of filters
		const { searchParams } = this.getUrlObject();
		const filterStr = searchParams.get(this.searchFilterKey);
		const activeFilters = filterStr ? filterStr.split(',') : [];

		const filterState = {};

		this.checkboxes.forEach((checkbox) => {
			const checkboxValue = checkbox.getAttribute('value');
			const isChecked = activeFilters.indexOf(checkboxValue) > -1;
			filterState[checkboxValue] = isChecked;
			checkbox.checked = isChecked;
		});

		this.setState(filterState);

		// Ensure that state is set.
		// This could also be done by upgrading
		//  the state to a Promise-based solution
		setTimeout(() => {
			this.setResetFilterVisibility();
		}, 1);
	}

	/**
	 * Submits form and calling function to set search value
	 * @param {Event} submitEvent
	 * @returns {void}
	 */
	onSubmit(e) {
		e.preventDefault();
		const searchValue = this.dom.input.value;
		this.generateFilterUrl(false);
		this.setSearchValue(this.searchWord, true, searchValue);
	}

	/**
	 * Reset form (input only)
	 * OBS: form.reset() cannot be triggered here. It would also reset filters
	 * @param {Event} event
	 * @returns {void}
	 */
	resetForm(e) {
		e.preventDefault();
		this.dom.input.value = '';
		this.resetFilters(false);
		this.setSearchValue(this.searchWord, true);
	}

	/**
	 * Reset filters
	 * @returns {void}
	 */
	resetFilters(reload = true) {
		this.checkboxes.forEach((checkbox) => {
			checkbox.checked = false;
		});

		const newState = this.getState();

		// Reset filters in state
		Object.keys(this.getState()).forEach((filter) => {
			newState[filter] = false;
		});

		this.setState(newState);
		this.setSearchValue(this.searchFilterKey, reload);
		this.setResetFilterVisibility();
	}

	/**
	 * Reveal and hide reset CTA
	 *
	 * @param {Boolean} isVisible
	 */
	toggleResetVisibility(isVisible = true) {
		if (this.resetAction) {
			// eslint-disable-next-line no-unused-expressions
			isVisible
				? this.resetAction.classList.remove(this.hideClass)
				: this.resetAction.classList.add(this.hideClass);
		}
	}

	/**
 * Recieve checkbox event to set state and generate url
 * @param {Event} e from checkbox
 */
	toggleFilter(e) {
		const newState = this.getState();
		const input = e.target;
		this.removeFocus(input);
		const isChecked = input.checked;
		const filterValue = input.getAttribute('value');
		let stateIndex = -1;

		Object.keys(this.getState()).forEach((key, i) => {
			if (key === filterValue) {
				stateIndex = i;
			}
		});

		// Assign new value to correct state object
		if (stateIndex > -1) {
			newState[filterValue] = isChecked;
		}

		this.setResetFilterVisibility();
		this.setState(newState);
		this.generateFilterUrl(true);
	}

	/**
	 * Toggle visibility of reset filters CTA
	 * - AKA this.dom.resetFilters
	 *
	 * @param {Boolean} isVisible
	 */
	setResetFilterVisibility() {
		// Check is every filter is unchecked
		const hasActiveFilters = !(Object.values(this.getState()).filter(val => val).length === 0);
		const resetFiltersCTA = this.dom.resetFilters;

		// eslint-disable-next-line no-unused-expressions
		hasActiveFilters
			? resetFiltersCTA.classList.remove(this.hideClass)
			: resetFiltersCTA.classList.add(this.hideClass);
	}

	/**
	 * Focus has to be present due to WCAG
	 *
	 * But focus needs to be removed when using mouse as pointer
	 * for better UX.
	 *
	 * Method attaches an eventlistener on mousemove and
	 * removes this method when the pointer is outside the input (filter).
	 *
	 * @param {HTMLInputElement} input
	 * @returns {void}
	 *
	 */

	removeFocus(input) {
		document.addEventListener('mousemove', function inputBlur(e) {
			if (e.target !== input) {
				input.blur();
				document.removeEventListener('mousemove', inputBlur);
			}
		});
	}

	/** ******************
	 * URL and history
	 * functions
	 *
	 ******************* */

	/**
	 * Prepare URL params.
	 * Key is mandatory, value is optional.
	 *
	 * @param {string} key search param key
	 * @param {boolean} reloadTable Flag to reload table
	 * @param {string?} value Value to set
	 * @returns {void}
	 */
	setSearchValue(key, reloadTable = false, value = '') {
		const { url, searchParams } = this.getUrlObject();

		if (value.length === 0) {
			searchParams.delete(key);
		} else {
			searchParams.set(key, value);
		}

		url.search = searchParams.toString();
		this.setHistory(url.href);

		// Check if table should reload
		if (reloadTable) {
			this.$datatable.DataTable().ajax.reload();
		}

		// Toggle reset visibility
		const isResetVisible = url.search.length !== 0;
		this.toggleResetVisibility(isResetVisible);
	}

	/**
	 * Replace history with a new URL
	 * @param {string} url
	 * @returns {void}
	 */
	setHistory(url) {
		window.history.replaceState({ path: url }, '', url);
	}

	/**
	 * Get search params from url bar
	 * @param {string} key key to search for
	 * @typedef {string} searchValue
	 */
	getSearchValue(key) {
		const { searchParams } = this.getUrlObject();
		return searchParams.get(key);
	}

	/**
	 * Prepare active filters string to be set as url parameter.
	 *
	 * @returns {void}
	 */
	generateFilterUrl(reload = false) {
		const activeFilters = [];
		const currentState = this.getState();

		Object.keys(currentState).forEach((key) => {
			if (currentState[key]) {
				activeFilters.push(key);
			}
		});

		this.setSearchValue(this.searchFilterKey, reload, activeFilters.toString());
	}

	/** ******************
 * Utils
 *
 ******************* */

	/**
	 * Fetches data
	 */
	fetchdata() {
		this.$datatable.DataTable().on('xhr', (e, settings, json) => {
			const total = json ? json.recordsTotal : 0;
			const dataTable = $('.dataTable');

			if (total === 0) {
				dataTable.addClass('dataTable--empty');
			} else {
				dataTable.removeClass('dataTable--empty');
			}

			this.total = total;
			this.paintCounter();

			setTimeout(() => {
				this.paintRows();
			}, 100);
		});
	}

	/**
	 * Get url-object
	 * @typedef {Object} Object containing url, querystring and search parameters as object
	 * @property {URL} url as URL
	 * @property {string} Querystring
	 * @property {URLSearchParams} searchParams in object
	 */
	getUrlObject() {
		const url = new URL(window.location);
		const queryString = url.search;
		const searchParams = new URLSearchParams(queryString);

		return {
			url,
			queryString,
			searchParams
		};
	}

	paintRows() {
		let tableRows = this.el.querySelectorAll('[data-ref="search-case__dataTable"] > tbody > tr');

		// IE 11 polyfill
		// https://stackoverflow.com/questions/41142932/ie-supports-foreach-when-invoked-fromthe-console-but-not-when-called-from-t
		if (!tableRows.forEach) {
			tableRows = objectToArray(tableRows);
		}

		tableRows.forEach((row) => {
			const anchorId = this.generateId();
			const anchor = row.querySelector('a');

			// Set anchor id
			if (anchor) {
				anchor.setAttribute('id', anchorId);
			}

			// Set tabindex and aria-labelledby
			row.setAttribute('tabIndex', '0');
			row.setAttribute('aria-labelledby', anchorId);

			// Set image or background
			const imageLocation = anchor.getAttribute('data-image');
			const rowStyle = row.querySelector('td').style;

			if (imageLocation) {
				rowStyle.backgroundImage = `URL(${imageLocation})`;
			} else {
				rowStyle.background = anchor.getAttribute('data-background');
			}

			// Click EventListener triggers click on href
			row.addEventListener('keypress', () => anchor.click());
		});
	}

	/**
	 * Fill data in counter fetched from endpoint.
	 */
	paintCounter() {
		const { countHeader } = this.dom;
		let templateText;
		const hasActiveFilters = !(Object.values(this.getState()).filter(val => val).length === 0);
		if (hasActiveFilters || this.dom.input.value.length > 0) {
			templateText = countHeader.getAttribute('data-heading-search');
		} else {
			templateText = countHeader.getAttribute('data-heading-total');
		}
		templateText = templateText.replace(/\{\{total\}\}/gi, this.total);
		countHeader.textContent = templateText;
	}

	/**
	 * OBS: Executed before printing and after printing to enable visible images.
	 * Remove backgronud image from td and insert in img + revert of this.
	 */
	toggleImages(visibleImages = false) {
		// Get all rows
		const rows = document.querySelector('.o-search-result-case').querySelectorAll('td');

		rows.forEach((row) => {
			const imagePrint = row.querySelector('.js-image');

			// Hide images
			if (!visibleImages) {
				imagePrint.classList.add(this.imageClassHide);
				return;
			}

			// Ensure background image
			if (row.style.backgroundImage.indexOf('url') > -1) {
				row.style.backgroundImage = '';
				imagePrint.classList.remove(this.imageClassHide);
				return;
			}

			const anchorPrintableClass = 'm-module-item__card--printable';
			const anchor = row.querySelector('.js-anchor');
			anchor.classList.add(anchorPrintableClass);
		});
	}

	/**
	 * Math.random should be unique because of its seeding algorithm.
	 * Convert it to base 36 (numbers + letters), and grab the first 9 characters
	 * after the decimal.
	 *
	 * @returns {string} generatedId
	 */

	generateId() {
		return '_' + Math.random().toString(36).substr(2, 9);
	}

	/** ******************
	 * Functions for state
	 *
	 ******************* */

	/**
	 * Sets state of class
	 * @param {Object} newState new state to be set
	 * @returns {void}
	 */
	setState(newState) {
		this._state = newState;
	}

	/**
	 * Get current state
	 * @return {Object} this._state
	 */
	getState() {
		return this._state;
	}

	/** ******************
	 * DataTables
	 *
	 ******************* */

	/**
	 * Prepare datatables by setting
	 * - $dataTables : $ | null
	 * - $container : $ | null
	 * - dataTableDefs : Array
	 * - dataTableColumns : Array
	 */
	initDataTables() {
		this.$datatable = $('[data-ref="search-case__dataTable"]');
		this.$container = $('[data-ref="search-case__container"]');

		this.dataTableDefs = [
			{ className: 'o-search-result-case__title', targets: [0] }
		];

		this.dataTableColumns = [
			{
				targets: 0,
				data(row) {
					let itemCopy = itemTemplate;
					itemCopy = itemCopy.replace(/\{\{theme\}\}/gi, row[0]);
					itemCopy = itemCopy.replace(/\{\{title\}\}/gi, row[1]);
					itemCopy = itemCopy.replace(/\{\{link\}\}/gi, row[2]);

					const image = row[3] ? row[3] : '';
					itemCopy = itemCopy.replace(/\{\{image\}\}/gi, image);

					return itemCopy;
				}
			}
		];
		this.paintRows();
		this.initDataTableList();
	}

	// The MOTHER
	// Datatable init with settings from previous functions
	initDataTableList() {
		const self = this;
		this.$datatable.DataTable({
			fnDrawCallback(oSettings) {
				if (oSettings._iDisplayLength > oSettings.fnRecordsDisplay()) {
					$(oSettings.nTableWrapper).find('.dataTables_paginate').hide();
					$('.dataTables_wrapper').addClass('dataTables_wrapper--no-paging');
				} else {
					$(oSettings.nTableWrapper).find('.dataTables_paginate').show();
				}
			},
			processing: false,
			serverSide: true,
			searching: false,
			ordering: false,
			deferRender: true,
			lengthChange: false,
			info: true,
			paging: true,
			pagingType: 'full_numbers',
			pageLength: Number(self.settings.pageSize),
			retrieve: true,
			language: {
				info: '_TOTAL_',
				emptyTable: self.settings.noResults,
				paginate: {
					next: '<span class="a-icon m-link-icon__icon"><svg class="a-icon__asset"><use xlink:href="#Arrow_right_icon" xmlns:xlink="http://www.w3.org/1999/xlink"></use></svg></span>',
					previous: '<span class="a-icon m-link-icon__icon"><svg class="a-icon__asset"><use xlink:href="#Arrow_left_icon" xmlns:xlink="http://www.w3.org/1999/xlink"></use></svg></span>',
					first: '<span class="a-icon m-link-icon__icon first-icon"><svg class="a-icon__asset"><use xlink:href="#Arrow_left_icon" xmlns:xlink="http://www.w3.org/1999/xlink"></use></svg></span><span class="first-text">Første</span> ',
					last: '<span class="last-text">Sidste</span><span class="a-icon m-link-icon__icon last-icon"><svg class="a-icon__asset"><use xlink:href="#Arrow_right_icon" xmlns:xlink="http://www.w3.org/1999/xlink"></use></svg></span>'
				}
			},
			ajax: {
				url: this.endpoint,
				data: (data) => {
					data.filters = [];
					Object.entries(self.getState()).forEach(
						([key, value]) => (value ? data.filters.push(key) : null)
					);

					data.filters = data.filters.toString();
					data.pageSize = self.settings.pageSize;
					data.searchWord = self.dom.input.value;
					data.contextId = self.settings.contextId;
					data.searchType = self.settings.searchType;
				}
			},
			initComplete: () => {
				this.paintCounter();
				this.paintRows();
			},
			columnDefs: self.dataTableDefs,
			columns: self.dataTableColumns
		});

		// Adding title attr after page has rendered
		$(window).on('load', () => {
			const buttonNext = document.querySelector('.paginate_button.next');
			const buttonPrev = document.querySelector('.paginate_button.previous');
			const buttonFirst = document.querySelector('.paginate_button.first');
			const buttonLast = document.querySelector('.paginate_button.last');

			if (buttonNext) {
				buttonNext.setAttribute('title', 'Næste');
			}

			if (buttonPrev) {
				buttonPrev.setAttribute('title', 'Tilbage');
			}

			if (buttonFirst) {
				buttonFirst.setAttribute('title', 'Første side');
			}

			if (buttonLast) {
				buttonLast.setAttribute('title', 'Sidste side');
			}
		});
	}
}

export default SearchCase;
